// TASK-3 REWRITE: LAB's BookDemo.tsx structure (bg-wash hero band + a
// rounded-2xl bg-card form panel, no `Panel` chrome) restored; headline/intro
// copy stays Workshop-branded per the Task 2 composition (content adaptation,
// not a styling revert). Behavior (endpoint, validation) is unchanged.
import { Eyebrow } from "@/components/Eyebrow";
import { DemoForm } from "@/components/DemoForm";

export default function BookDemo() {
  const tz =
    typeof Intl !== "undefined" ? Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC" : "UTC";
  return (
    <>
      <section className="bg-wash border-b border-border">
        <div className="mx-auto max-w-3xl px-6 py-16 text-center">
          <Eyebrow>Book a demo</Eyebrow>
          <h1 className="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">
            Watch a design meet real physics.
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-lg text-muted-foreground">
            Pick a couple of slots — we'll walk you through the Workshop live: your use case, the
            component library, and the Isaac-backed digital twin.
          </p>
        </div>
      </section>
      <section className="mx-auto max-w-3xl px-6 py-12">
        <div className="rounded-2xl border border-border bg-card p-6 shadow-soft sm:p-8">
          <DemoForm endpoint="/api/demo-request" tz={tz} />
        </div>
      </section>
    </>
  );
}
